import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CubeAPIService } from 'app/api/cube.api.service';
import { AppState } from 'app/reducers';
import { parseErrorMessage } from 'app/utils/callstate';
import * as _ from 'lodash';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
    CubeActions,
    CubeActionTypes,
    CubeCancelled,
    CubeLoaded,
    CubeRequested,
    CubeReloadRequested
} from './cube.actions';
import { selectCurrentPeriod, selectCurrentCompanyId } from '../company/selectors/companies.ui.selectors';

@Injectable()
export class CubeEffects {
    @Effect()
    loadCube$ = this.actions$.pipe(
        ofType<CubeRequested>(CubeActionTypes.CubeRequested),
        switchMap(action => {
            // tslint:disable-next-line: no-shadowed-variable
            const { companyId, key, filter } = action.payload;
            return this.cubeApiService
                .Cube(companyId, key, filter)
                .pipe(
                    map(
                        cube => {
                            if (key.between) {
                                // console.log('Should remove AN');
                                const firstYear = key.between.split('|')[0];
                                const cubeFiltered = _.filter(cube, c => {
                                    if (c.journal === 'AN'){
                                        return c.key.split('#')[0] === firstYear;
                                    }
                                    return true;
                                });
                                
                                console.log('Get AN only ', firstYear);
                                return new CubeLoaded({ cube: cubeFiltered });

                            }
                            return new CubeLoaded({ cube });
                        }
                    ),
                    catchError(error => {
                        const errorMessage = parseErrorMessage(error);
                        return of(new CubeCancelled({ errorMessage }));
                    })
                );
        })
    );

    @Effect()
    reloadCube$ = this.actions$.pipe(
        ofType<CubeReloadRequested>(CubeActionTypes.CubeReloadRequested),
        withLatestFrom(
            this.store.select(selectCurrentCompanyId),
            this.store.select(selectCurrentPeriod)
        ),
        switchMap(([_, companyId, period]) =>
            this.cubeApiService
                .Cube(companyId, period.keyStringFilterInput)
                .pipe(
                    map(cube => new CubeLoaded({ cube }),
                    catchError(error => {
                        const errorMessage = parseErrorMessage(error);
                        return of(new CubeCancelled({ errorMessage }));
                    })
                )
        ))
    );

    constructor(
        private actions$: Actions<CubeActions>,
        private store: Store<AppState>,
        private cubeApiService: CubeAPIService
    ) {}
}
